import { MEDIA_BASE_URL } from "./constants";

/**
 * Reads image URL from invitation upload API responses.
 * Supports { data: { url, file_path } }, flat { url }, or file_path + MEDIA_BASE_URL.
 */
export function pickInvitationUploadImageUrl(axiosResponse) {
  const body = axiosResponse?.data;
  if (body == null) return null;

  if (typeof body.data === "string") {
    const s = body.data.trim();
    if (/^https?:\/\//i.test(s)) return s;
  }

  const nested =
    body.data != null && typeof body.data === "object" ? body.data : null;
  const bag = nested ?? body;

  let url = bag?.url ?? bag?.file_url;
  if (typeof url === "string" && /^https?:\/\//i.test(url)) {
    return url.trim();
  }

  const path = bag?.file_path ?? body?.file_path;
  if (typeof path === "string" && path.length) {
    const base = (MEDIA_BASE_URL || "").replace(/\/$/, "");
    const p = path.replace(/^\//, "");
    if (base) {
      return `${base}/${p}`;
    }
  }

  if (typeof url === "string" && url.length) {
    return url.trim();
  }

  return null;
}
